import { chatGPT, mj, openai } from '@/config/model';

export default {
	name: 'Privacy',

	data() {
		return {
			chatGPT,
			openai
		};
	}
};